// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3GIWF","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2WvO5","obliqueLine":"membershipbadge_obliqueLine__25vbO"};